import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex justify-start items-start" }
const _hoisted_2 = { class: "flex flex-col md:w-72" }
const _hoisted_3 = { class: "text-sm font-bold leading-4 flex items-center" }
const _hoisted_4 = { class: "leading-4" }
const _hoisted_5 = { class: "leading-4" }
const _hoisted_6 = { class: "leading-4" }
const _hoisted_7 = { class: "text-sm font-normal leading-4 mt-2 flex items-center" }
const _hoisted_8 = {
  key: 0,
  class: "leading-4 text-dark-2"
}
const _hoisted_9 = {
  key: 1,
  class: "leading-4 text-dark-2"
}
const _hoisted_10 = { class: "hidden md:flex flex-col w-40" }
const _hoisted_11 = { class: "text-sm font-bold leading-4" }
const _hoisted_12 = { class: "text-sm font-normal text-dark-2 leading-4 mt-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-bold leading-4" }, " - ", -1)
const _hoisted_14 = { class: "text-sm font-normal text-dark-2 leading-4 mt-2" }
const _hoisted_15 = { class: "hidden lg:flex flex-col w-40" }
const _hoisted_16 = {
  key: 0,
  class: "text-sm font-bold leading-4"
}
const _hoisted_17 = {
  key: 1,
  class: "text-sm font-bold"
}
const _hoisted_18 = { class: "text-sm font-normal text-dark-2 leading-4 mt-2" }
const _hoisted_19 = { class: "hidden md:flex flex-col" }
const _hoisted_20 = {
  key: 0,
  class: "text-sm font-bold leading-4"
}
const _hoisted_21 = {
  key: 1,
  class: "text-sm font-bold"
}
const _hoisted_22 = { class: "text-sm font-normal text-dark-2 leading-4 mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_dropdown_menu_item = _resolveComponent("dropdown-menu-item")!
  const _component_dropdown_menu_divider = _resolveComponent("dropdown-menu-divider")!
  const _component_dropdown_menu = _resolveComponent("dropdown-menu")!
  const _component_card_list_item = _resolveComponent("card-list-item")!

  return (_openBlock(), _createBlock(_component_card_list_item, {
    title: _ctx.mailTitle,
    onEdit: _ctx.editMail,
    onView: _ctx.viewMail,
    "context-menu": true,
    action: _ctx.action
  }, {
    contextmenu: _withCtx(() => [
      _createVNode(_component_dropdown_menu, {
        type: "contextmenu",
        "data-test": "toggle"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_dropdown_menu_item, {
            label: _ctx.$t('general.preview'),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openMailPreview(_ctx.mail.id)))
          }, null, 8, ["label"]),
          _createVNode(_component_dropdown_menu_divider),
          _createVNode(_component_dropdown_menu_item, {
            label: _ctx.$t('pages.mails.saveAsTemplate'),
            onClick: _ctx.saveAsTemplate
          }, null, 8, ["label", "onClick"]),
          _createVNode(_component_dropdown_menu_item, {
            label: _ctx.$t('general.duplicate'),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.duplicateMail(_ctx.mail.id)))
          }, null, 8, ["label"]),
          (_ctx.status === 'draft')
            ? (_openBlock(), _createBlock(_component_dropdown_menu_item, {
                key: 0,
                label: _ctx.$t('general.delete'),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteMail(_ctx.mail.id)))
              }, null, 8, ["label"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            (_ctx.mail.publishUp && _ctx.inFuture)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_app_icon, {
                    name: "Mail",
                    size: "4",
                    class: "mr-1"
                  }),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("components.mails.listItem.scheduled")) + " " + _toDisplayString(_ctx.sentOn), 1)
                ], 64))
              : (_ctx.mail.publishUp && !_ctx.inFuture)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_app_icon, {
                      name: "CheckCircle",
                      size: "4",
                      class: "text-green-400 mr-1"
                    }),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("components.mails.listItem.sentOn")) + " " + _toDisplayString(_ctx.sentOn), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createVNode(_component_app_icon, {
                      name: "Mail",
                      size: "4",
                      class: "mr-1"
                    }),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("components.mails.listItem.notYetScheduled")), 1)
                  ], 64))
          ]),
          _createElementVNode("span", _hoisted_7, [
            _createVNode(_component_app_icon, {
              name: "Users",
              size: "4",
              class: "mr-1"
            }),
            (_ctx.mail.lists.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.listLabel), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, "All contacts"))
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_ctx.mailStats !== undefined && _ctx.mailStats.total_sent)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.mailStats.total_sent) + " " + _toDisplayString(_ctx.$t("components.mails.listItem.mailsSent")), 1),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.mailStats.open_rate.toFixed(1)) + "% " + _toDisplayString(_ctx.$t("components.mails.listItem.openRate")), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_13,
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("components.mails.listItem.mailsSent")), 1)
              ], 64))
        ]),
        _createElementVNode("div", _hoisted_15, [
          (_ctx.mailStats !== undefined)
            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.mailStats.total_conversions), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_17, "-")),
          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("components.mails.listItem.conversions")), 1)
        ]),
        _createElementVNode("div", _hoisted_19, [
          (_ctx.mailStats !== undefined)
            ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.mailStats.total_revenue), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_21, "-")),
          _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("components.mails.listItem.revenueByMail")), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "onEdit", "onView", "action"]))
}